"use client"

import { useEffect, useState } from "react"
import UploadProduct from "../components/UploadProduct"
import AdminProductCard from "../components/AdminProductCard"
import summaryApi from "../common/index"

const AllProducts = () => {
  const [openUploadProduct, setOpenUploadProduct] = useState(false)
  const [allProduct, setAllProduct] = useState([])
  const [filteredProduct, setFilteredProduct] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")

  const fetchAllProduct = async () => {
    setLoading(true) // Set loading to true when fetching starts
    const response = await fetch(summaryApi.allProduct.url)
    const dataResponse = await response.json()
    console.log("Data All Products:", dataResponse)
    setAllProduct(dataResponse?.data || [])
    setFilteredProduct(dataResponse?.data || []) // Initialize filtered products
    setLoading(false) // Set loading to false when fetching ends
  }

  useEffect(() => {
    fetchAllProduct()
  }, [])

  useEffect(() => {
    if (searchTerm === "") {
      setFilteredProduct(allProduct)
    } else {
      setFilteredProduct(
        allProduct.filter(
          (product) =>
            product.productName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            product.brandName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            product.section?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            product.generalCategory?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            product.essentialsCategory?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            product.category?.toLowerCase().includes(searchTerm.toLowerCase()),
        ),
      )
    }
  }, [searchTerm, allProduct])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
      </div>
    )
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="bg-white py-4 px-6 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
        <button
          className="py-3 px-6 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition-colors shadow-md"
          onClick={() => setOpenUploadProduct(true)}
        >
          Upload Product
        </button>
        <input
          type="text"
          placeholder="Search by name, brand, category..."
          className="py-3 px-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition w-full md:w-1/3"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
        {filteredProduct.length > 0 ? (
          filteredProduct.map((product, index) => (
            <AdminProductCard data={product} key={product._id || index} fetchData={fetchAllProduct} />
          ))
        ) : (
          <div className="col-span-full flex flex-col items-center py-12">
            <div className="w-32 h-32 bg-gray-200 rounded-full flex items-center justify-center mb-4">
              <svg className="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2 2v-5m16 0h-2M4 13h2m13-8l-4 4m0 0l-4-4m4 4V3"
                />
              </svg>
            </div>
            <p className="text-gray-500 text-lg">No products found</p>
            <p className="text-gray-400 text-sm mt-1">Try adjusting your search terms</p>
          </div>
        )}
      </div>

      {openUploadProduct && <UploadProduct onClose={() => setOpenUploadProduct(false)} fetchData={fetchAllProduct} />}
    </div>
  )
}

export default AllProducts
